import React from 'react';
import Dashboard from '../Dashboard';
import DirectorGoalsPanel from '../director/DirectorGoalsPanel';

function OperationalPerformanceViews({
  currentPath = '',
  dashboardData,
  locationCode = '',
  locationName = '',
  onPerformanceContextChange = () => {},
  period,
  performanceContext,
  selectedManager
}) {
  const isScorecardRoute = currentPath === '/location-scorecard';
  const isGoalsRoute = currentPath === '/goals';

  return (
    <>
      {isScorecardRoute && (
        <Dashboard
          data={dashboardData}
          period={period}
          manager={selectedManager}
          dataVersion={0}
          variant="director_scorecard"
        />
      )}

      {isGoalsRoute && (
        <DirectorGoalsPanel
          readOnly
          locationLabel={`${locationCode} - ${locationName}`}
          selectedLocationCode={locationCode}
          performanceContext={performanceContext}
          onPerformanceContextChange={onPerformanceContextChange}
          selectedManagerIdExternal={String(selectedManager || '')}
        />
      )}
    </>
  );
}

export default OperationalPerformanceViews;
